import type { Nullable } from 'corgi-types';

import { REGEX_GIFT_CARD_PIN, REGEX_START_WITH_LETTER } from 'common/constants/form';

export const formatGiftCardCodeValue = (value: Nullable<string>) => {
  if (!value) {
    return '';
  }

  return value.toUpperCase();
};

export const startsWithLetter = (value: string) => REGEX_START_WITH_LETTER.test(value);

export const isValidGiftCardPin = (value: string) => REGEX_GIFT_CARD_PIN.test(value);
